import { useEffect, useState, useCallback } from "react";
import api, { authFileUrl } from "@/lib/api";
import { Briefcase, Loader2, FileText, Mail, Phone } from "lucide-react";

export default function Applications() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    api.get("/careers/applications").then(({ data }) => setApps(data)).catch((e) => console.error(e)).finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  if (loading) return <div className="grid place-items-center py-20 text-teal-400"><Loader2 className="w-8 h-8 animate-spin" /></div>;

  return (
    <div>
      <div className="mb-8"><h1 className="text-2xl sm:text-3xl font-extrabold text-[#0B3B39]">Career Applications</h1><p className="text-slate-600 mt-1">{apps.length} candidate submissions.</p></div>
      {apps.length === 0 ? (
        <div className="oj-card p-12 text-center text-slate-500"><Briefcase className="w-10 h-10 mx-auto mb-3 opacity-50" />No applications yet.</div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {apps.map((a) => (
            <div key={a.id} className="oj-card p-6" data-testid={`application-${a.id}`}>
              <div className="flex items-start justify-between gap-3">
                <div><h3 className="font-bold text-white">{a.name}</h3><div className="text-sm text-teal-600 mt-0.5">{a.position}</div></div>
                <span className="text-[10px] font-mono text-slate-500">{new Date(a.created_at).toLocaleDateString()}</span>
              </div>
              <div className="flex flex-wrap gap-4 text-xs text-slate-600 mt-3">
                <a href={`mailto:${a.email}`} className="flex items-center gap-1.5 hover:text-amber-300"><Mail className="w-3.5 h-3.5 text-teal-400" /> {a.email}</a>
                {a.phone && <span className="flex items-center gap-1.5"><Phone className="w-3.5 h-3.5 text-teal-400" /> {a.phone}</span>}
              </div>
              {a.cover && <p className="text-sm text-slate-600 mt-3 leading-relaxed line-clamp-3">{a.cover}</p>}
              {a.resume_path && <a href={authFileUrl(a.resume_path)} target="_blank" rel="noreferrer" className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-teal-400 hover:text-amber-300" data-testid={`application-resume-${a.id}`}><FileText className="w-4 h-4" /> View Resume</a>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
